import { Box, Step, StepButton, StepLabel, Stepper, Typography } from '@mui/material';
import React from 'react';

export type FormStepperProps = {
  steps: string[];
  activeStep: number;
  stepCounterLabel: string;
  onStepClick?: (step: number) => void;
};

const FormStepper: React.FC<FormStepperProps> = ({ steps, activeStep, stepCounterLabel, onStepClick }) => (
  <Box data-testid="form-stepper" sx={{ paddingBottom: '16px' }}>
    <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary', marginBottom: '8px' }}>
      {stepCounterLabel}
    </Typography>
    <Stepper activeStep={activeStep} nonLinear>
      {steps.map((label, index) => {
        const completed = index < activeStep;
        return (
          <Step key={label} completed={completed}>
            {completed && onStepClick ? (
              <StepButton onClick={() => onStepClick(index)}>{label}</StepButton>
            ) : (
              <StepLabel>{label}</StepLabel>
            )}
          </Step>
        );
      })}
    </Stepper>
  </Box>
);

export default FormStepper;
